import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgencySettingsComponent } from './agency-settings.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AgencySettingsRoutingModule } from './agency-settings-routing.module';
@NgModule({
  declarations: [
    AgencySettingsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
   
    NgxUiLoaderModule,
    AgencySettingsRoutingModule
  ],
 
})
export class AgencySettingsModule { }

